// extracted by mini-css-extract-plugin
export default {"cls1":"jzftAgUYMiujun8ju1fM","cls2":"SnHysTMlGiHkPtyYf37M jzftAgUYMiujun8ju1fM"};